import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import { useAuthContext } from 'modules/auth/context';
import { saveAttemptFeedback } from './api';
import type { FeedbackInput } from './types';
import { feedbackKey } from './useAttemptFeedback';

/** Saves (or replaces) the feedback and puts the saved copy straight into the cache. */
export function useSaveFeedback(attemptId: string) {
  const { state } = useAuthContext();
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();
  const userId = state.user?.id;

  return useMutation({
    mutationFn: (input: FeedbackInput) => saveAttemptFeedback(attemptId, input),
    onSuccess: (saved) => {
      // Keyed by the attempt the answer is about, so a late answer cannot land on another attempt.
      queryClient.setQueryData(feedbackKey(userId, saved.attemptId), saved);
      toast.success(t('feedback.thanks_title'), { description: t('feedback.thanks_description') });
    },
    onError: () => {
      toast.error(t('feedback.save_error_title'), { description: t('feedback.save_error_description') });
    },
  });
}
